export const kuchniaData = {
    order: 4,
    name: 'kuchnia',
    title: 'Kuchnia',
    iconSrc: 'pic_kuchnia.svg',
    headlineText:
        'W ciągu naszego życia ponad 3,5 roku zajmuje nam jedzenie, a 2,5 roku gotowanie. Dbajmy o środowisko również w kuchni!',
    mainText:
        'Niestety, nasz kraj należy do niechlubnej czołówki europejskiej pod względem marnowania żywności. Do wyrzucania jedzenia przyznaje się aż 39% mieszkańców Polski. Wg danych Millward Brown, Polacy co roku wyrzucają ok. 9 mln ton żywności, przy 90 mln ton dla całej UE. Ta ilość to ok. 230 kg przypadające rocznie na każde gospodarstwo domowe, co w przeliczeniu na złotówki daje ok. 2 tys. zł – aż tyle pieniędzy tracimy co roku, marnując jedzenie.',
    mainVideoSrc: '',
    odpadySection: [
        {
            text:
                'Unikaj wyrzucania żywności – rób odpowiedzialne zakupy i uzupełniaj lodówkę na bieżąco.',
        },
        {
            text:
                'W pierwszej kolejności wykorzystuj produkty, których termin ważności dobiega końca. ',
        },
        {
            text: 'Dlaczego marnujemy żywność?',
            picSrc: 'pics/pic-11.png',
        },
        {
            text:
                'Do przechowywania produktów i gotowych dań używaj wielorazowych opakowań – nadadzą się na przykład pojemniki po lodach czy słoiki.',
        },
        {
            text:
                'Niektóre produkty wciąż można wykorzystać, pomimo że nie są już pierwszej świeżości. Wystarczy podejść do gotowania nieco bardziej kreatywnie!',
        },
        {
            text:
                'Dodatkowe porcje przygotowanych posiłków, których nie jesteśmy w stanie zjeść od razu, można zamrozić (gotowe produkty w wysokich temperaturach psują się szczególnie szybko).',
        },
        {
            text:
                'Używaj ekologicznych zamienników produktów kuchennych. Zamiast tradycyjnych gąbek do mycia naczyń wykorzystuj ich ekologiczne odpowiedniki, a zamiast jednorazowych ręczników papierowych używaj bawełnianych ściereczek.',
        },
        {
            text: 'Przygotowuj własne przetwory.',
        },
        {
            text: 'Do najczęściej wyrzucanych produktów należą:<br><br>',
            picList: [
                {
                    picSrc: 'pics/pic-4.png',
                    caption: 'Pieczywo – 51%',
                },
                {
                    picSrc: 'pics/pic-5.png',
                    caption: 'Wędliny – 39%',
                },
                {
                    picSrc: 'pics/pic-6.png',
                    caption: 'Warzywa – 33%',
                },
                {
                    picSrc: 'pics/pic-7.png',
                    caption: 'Owoce – 32%',
                },
                {
                    picSrc: 'pics/pic-8.png',
                    caption: 'Ziemniaki – 17%',
                },
                {
                    picSrc: 'pics/pic-9.png',
                    caption: 'Jogurty – 16%',
                },
                {
                    picSrc: 'pics/pic-10.png',
                    caption: 'Dania gotowe – 14%',
                },
            ],
        },
    ],
    klimatSection: [
        {
            text:
                'Ograniczając spożycie mięsa, przyczyniasz się do ograniczenia zanieczyszczenia i degradacji środowiska oraz dbasz o swoje zdrowie. Hodowla zwierząt jest odpowiedzialna za 18% emisji CO2, 35% emisji metanu i aż 65% emisji tlenku azotu! Ponadto, do produkcji 1 kg wołowiny potrzebne jest 14.500 litrów wody, a do 1 kg wieprzowiny – 5.990 litrów.',
        },
    ],
    energiaSection: [
        {
            text:
                'Gotując, używaj garnków z pokrywką. Skraca to czas przygotowania posiłku, a przez to pozwala zaoszczędzić prąd i gaz (nawet do 30%). Dania jednogarnkowe są nie tylko smaczne, ale i przyjazne dla kieszeni i środowiska.',
        },
        {
            text:
                'Maksymalnie wykorzystuj piekarnik, gdy z niego korzystasz (piecz kilka dań naraz, lub jedno po drugim). Pozwala to zaoszczędzić sporo energii potrzebnej do nagrzania urządzenia.',
        },
        {
            text:
                'Otwieraj drzwiczki piekarnika jak najrzadziej (to zredukuje zużycie energii o 10%), aby uniknąć znaczących strat ciepła. Wcześniejsze nagrzanie piekarnika nie zawsze jest konieczne. ',
        },
        {
            text:
                'Nie umieszczaj urządzeń chłodzących w ciepłych pomieszczeniach, zwłaszcza w pobliżu kaloryferów, grzejników, pieców lub w miejscach silnie nasłonecznionych.',
        },
        {
            text:
                'Ustaw lodówkę w taki sposób, aby zachować odpowiednią odległość od ściany, co usprawnia wentylację powietrza w lodówce.',
        },
        {
            text:
                'Zamrożone produkty rozmrażaj w lodówce, ponieważ pochłaniają one ciepło jej wnętrza i w efekcie lodówka zużyje mniej energii do ochłodzenia pozostałych produktów.',
        },
        {
            text: 'Nie wkładaj ciepłych ani gorących produktów do lodówki.',
        },
        {
            text:
                'Dbaj o czystość uszczelki na drzwiach lodówki. Jej szczelność można sprawdzić przy pomocy kartki papieru – łatwo przesuwająca się kartka pomiędzy drzwiami a lodówką sygnalizuje konieczność wymiany uszczelki.',
        },
        {
            text:
                'Opuszczając dom na dłużej, temperaturę w chłodziarce podnieś o kilka stopni. Jeśli wyjeżdżasz na dłużej niż 2 tygodnie, wyłącz zupełnie urządzenie, pozostawiając uchylone drzwi.',
        },
    ],
    powietrzeSection: [],
    wodaSection: [
        {
            text:
                'Ogranicz zużycie wody podczas ręcznego mycia naczyń. Korzystając ze zmywarki, zawsze włączaj tryb eco, a przed włożeniem do niej naczyń nie płucz ich. ',
        },
        {
            text:
                'Zamiast kupować wodę butelkowaną, pij wodę z kranu. W celu jej zmiękczenia i poprawienia smaku zamontuj w kranie filtr lub zaopatrz się w dzbanek filtrujący. Zaoszczędzisz w ten sposób nawet kilkaset złotych rocznie!',
        },
        {
            text: '',
            picSrc: 'pics/pic-20.png',
            caption: 'W Europie ponad 100 mln osób nie ma dostępu do czystej wody pitnej',
        },
    ],
    czyWieszSection: [
        {
            text:
                '… całkowicie rezygnując z mięsa lub ograniczając jego spożycie do 500 gram tygodniowo, zmniejszasz u siebie  ryzyko zachorowania na cukrzycę typu drugiego, wysokie ciśnienie krwi, a nawet nowotwory?...',
            more:
                'Takie informacje podaje Światowa Fundacja Badań nad Rakiem (WCRF, ang. World Cancer Research Found), Światowa Organizacja Zdrowia (WHO, ang. World Health Organization) oraz Europejski Urząd ds. Bezpieczeństwa Żywności (EFSA, ang. European Food Safety Authority)',
        },
        {
            text:
                '...przemysł mięsny wiąże się z zagrożeniem, że wszelkie znane nam antybiotyki przestaną działać?...',
            more:
                'Przez zapobiegawcze faszerowanie zwierząt antybiotykami zwiększa się ryzyko powstania odpornych na nie superbakterii, co Światowej Organizacji Zdrowia (WHO, ang. World Health Organization) ogłosiło światowym zagrożeniem dla zdrowia.' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://www.who.int/news-room/detail/07-11-2017-stop-using-antibiotics-in-healthy-animals-to-prevent-the-spread-of-antibiotic-resistance">https://www.who.int/news-room/detail/07-11-2017-stop-using-antibiotics-in-healthy-animals-to-prevent-the-spread-of-antibiotic-resistance</a>' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://www.wcrf.org/dietandcancer/recommendations/limit-red-processed-meat">https://www.wcrf.org/dietandcancer/recommendations/limit-red-processed-meat</a>' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://www.iarc.fr/wp-content/uploads/2018/07/pr240_E.pdf">https://www.iarc.fr/wp-content/uploads/2018/07/pr240_E.pdf</a>',
        },
        {
            text: '…w Jastrzębiu-Zdroju wodę można pić prosto z kranu?...',
            more:
                'Jastrzębski Zakład Wodociągów i Kanalizacji zapewnia, że jakość wody dostarczanej do mieszkańców jest wzorcowa, ma dobry smak i neutralny zapach. Jest znacznie tańsza niż butelkowa, a przy tym bardzo zdrowa i ekologiczna. Posiada idealną czystość mikrobiologiczną, a wszystkie parametry fizyko-chemiczne są doskonałe, co potwierdzają regularnie przeprowadzane badania.',
        },
    ],
};
